// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"38675d99","872":"ae94b958"}[chunkId] + ".js";
};